import blankRoutes from "./blank.js";
import informationRoutes from "./information.js";
import joinUsRoutes from "./joinUs.js";

export const routes = [
  {
    path: "/",
    component: () => import("@/layouts/index.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/Home/index.vue"),
        meta: {
          mobilePath: "/homeIndex",
          title: "首页",
        },
      },
      {
        path: "brmaomao",
        component: () => import("@/views/Maomao/index.vue"),
        meta: {
          activityIframe: true,
          mobilePath: "/brmaomao",
          useShortMobileQuery: true,
          title: "MaoMao",
        },
      },
      // 客户-start
      {
        path: "clients",
        component: () => import("@/views/Clients/index"),
        children: [
          {
            path: "vip",
            component: () => import("@/views/Clients/VIP/index.vue"),
            meta: {
              title: "成为VIP",
            },
          },
          {
            path: "c2c",
            component: () => import("@/views/Clients/C2C/index.vue"),
            meta: {
              mobilePath: "/ctc",
              title: "运费查询",
            },
          },
          {
            path: "cases",
            component: () => import("@/views/Clients/Cases/index.vue"),
            meta: {
              title: "客户案例",
            },
          },
          // 优惠券活动中心
          {
            path: "activityList",
            component: () => import("@/views/Service/ActivityList/index.vue"),
            meta: {
              mobilePath: "/actCenterList",
              useShortMobileQuery: true,
              title: "热门活动",
            },
          },
        ],
      },
      // 客户-end
      // 服务-start
      {
        path: "service",
        component: () => import("@/views/Service/index"),
        children: [
          {
            path: "b2c",
            component: () => import("@/views/Service/B2C/index.vue"),
            meta: {
              mobilePath: "/btc",
              title: "B2C服务", // 对应原-合作意向-cooperationIntention
            },
          },
          {
            path: "c2c",
            component: () => import("@/views/Clients/C2C/index.vue"),
            meta: {
              mobilePath: "/ctc",
              title: "C2C服务", // 对应原-运费计算-freightInquiry
            },
          },
          {
            path: "cbt",
            component: () => import("@/views/Service/CBT/index.vue"),
            meta: {
              mobilePath: "/cbt",
              title: "CBT服务",
            },
          },
          {
            path: "fulfill",
            component: () => import("@/views/Service/Fulfill/index.vue"),
            meta: {
              title: "云仓",
              mobilePath: "/fulfill",
            },
          },
        ],
      },
      // 服务-end
      // 关于我们-start
      {
        path: "aboutus",
        component: () => import("@/views/AboutUs/index"),
        children: [
          {
            path: "values",
            component: () => import("@/views/AboutUs/Values/index.vue"),
            meta: {
              title: "企业文化",
            },
          },
          {
            path: "history",
            component: () => import("@/views/AboutUs/History/index.vue"),
            meta: {
              title: "发展历史",
            },
          },
          // {
          //   path: "awards",
          //   component: () => import("@/views/AboutUs/Awards/index.vue"),
          //   meta: {
          //     title: "认证和奖项",
          //   },
          // },
        ],
      },
      // 关于我们-end
      // 联系我们-start
      {
        path: "contactus",
        component: () => import("@/views/ContactUs/index"),
        children: [
          {
            path: "b2c",
            component: () => import("@/views/Service/B2C/index.vue"),
            meta: {
              mobilePath: "/btc",
              title: "合作意向", // 对应原-合作意向-cooperationIntention
            },
          },
          {
            path: "orderFeedback",
            name: "OrderFeedback",
            component: () => import("@/views/ContactUs/OrderFeedback/index.vue"),
            meta: {
              title: "订单反馈",
            },
          },
          {
            path: "supervise",
            name: "Supervise",
            component: () => import("@/views/ContactUs/Supervise/index.vue"),
            meta: {
              title: "环保反馈",
            },
          },
        ],
      },
      // 联系我们-end
      // 个人中心--start
      {
        path: "personal",
        component: () => import("@/views/Personal/index.vue"),
        meta: {
          title: "个人中心",
        },
        children: [
          {
            path: "",
            redirect: "personalMsg", // 重定向到 personalMsg
          },
          {
            path: "personalMsg",
            name: "personalMsg",
            component: () => import("@/views/Personal/personalMsg/index.vue"),
            meta: {
              mobilePath: "/userinfo",
              title: "个人中心",
            },
          },
          {
            path: "singleOrder",
            name: "singleOrder",
            component: () => import("@/views/Personal/singleOrder/index.vue"),
            meta: {
              title: "立即下单",
              mobilePath: "/singleOrder",
              requireLogin: true,
            },
          },
          {
            path: "orderResult/:id",
            name: "orderResult",
            meta: {
              mobilePath: "/singleOrder",
              title: "订单结果",
            },
            component: () => import("@/views/Personal/singleOrder/orderResult.vue"),
          },
          {
            path: "orderPay/:id",
            name: "orderPay",
            meta: {
              title: "支付",
              mobilePath: "/paymentMethod",
              // 映射关系 params.id → query.orderId
              mobileQueryMap: {
                id: "orderId",
              },
            },
            component: () => import("@/views/Personal/singleOrder/orderPay.vue"),
          },
          {
            path: "freightQuery",
            name: "freightQuery",
            component: () => import("@/views/Personal/freightQuery/index.vue"),
            meta: {
              mobilePath: "/ctc",
              title: "运单费用",
            },
          },
          {
            path: "myOrdersList",
            name: "myOrdersList",
            component: () => import("@/views/Personal/myOrdersList/index.vue"),
            meta: {
              title: "订单列表",
            },
          },
          {
            path: "batchPay",
            name: "batchPay",
            component: () => import("@/views/Personal/myOrdersList/batchPay/index.vue"),
            meta: {
              title: "批量支付",
            },
          },
          {
            path: "trajectoryQuery",
            name: "trajectoryQuery",
            component: () => import("@/views/TrajectoryQuery/index.vue"),
            meta: {
              mobilePath: "/expressTracking",
              title: "快件跟踪",
            },
          },
          {
            path: "addressBook",
            name: "addressBook",
            component: () => import("@/views/Personal/addressBook/index.vue"),
            meta: {
              title: "地址簿",
            },
          },
          {
            path: "batchImport",
            name: "batchImport",
            component: () => import("@/views/Personal/batchImport/index.vue"),
            meta: {
              title: "批量导入",
            },
          },
          {
            path: "batchImportList",
            name: "batchImportList",
            props: true,
            component: () => import("@/views/Personal/batchImport/list.vue"),
          },
          {
            path: "afterSales",
            name: "afterSales",
            props: true,
            component: () => import("@/views/Personal/afterSales/index.vue"),
            meta: {
              title: "售后管理",
            },
          },
          {
            path: "couponList",
            name: "couponList",
            props: true,
            component: () => import("@/views/Personal/couponList/index.vue"),
            meta: {
              title: "我的优惠券",
            },
          },
          {
            path: "wallet",
            name: "wallet",
            component: () => import("@/views/Personal/wallet/index.vue"),
            meta: {
              title: "我的钱包",
            },
          },
          {
            path: "maomaoPet",
            name: "maomaoPet",
            component: () => import("@/views/Personal/maomaoPet/index.vue"),
            meta: {
              title: "MaoMao Pet",
            },
          },
        ],
      },
      // 个人中心--end
      // 加入我们 --start
      {
        path: "joinUs",
        component: () => import("@/views/JoinUs/index.vue"),
        children: [...joinUsRoutes],
      },
      // 加入我们 --end
      // 信息 --start
      {
        path: "information",
        component: () => import("@/views/Information/index.vue"),
        children: [...informationRoutes],
      },
      // 信息 --end
      {
        path: "trajectoryQuery",
        name: "trajectoryQuery",
        component: () => import("@/views/TrajectoryQuery/index.vue"),
        meta: {
          mobilePath: "/expressTracking",
          title: "快件跟踪",
        },
      },
      {
        path: "networkSelect",
        name: "networkSelect",
        component: () => import("@/views/NetworkSelect/index.vue"),
        meta: {
          mobilePath: "/selectNetwork",
          title: "网点查询",
        },
      },
      {
        path: "Bling",
        name: "Bling",
        component: () => import("@/views/Bling/index.vue"),
      },
      {
        path: "cooperationIntention",
        redirect: {
          path: "/service/b2c",
        },
      },
      {
        path: "logoff",
        name: "logoff",
        component: () => import("@/views/Personal/personalMsg/logoff.vue"),
        meta: {
          mobilePath: "/accountAgree",
          title: "注销协议",
        },
      },
    ],
  },
  ...blankRoutes,
  {
    path: "*",
    redirect: { path: "/" },
  },
];
